module.exports = __webpack_public_path__ + "static/media/img142.ff065e5a.jpg";